import { baseEnvironment } from './environment.base';
import { AppStage } from '../app/shared/enums/app-state.enum';

export const environment = {
  ...baseEnvironment,
  appStage: AppStage.dev,
  auth: {
    ...baseEnvironment.auth,
    authority: 'https://auth-service-dev.hottgenroth.de',
  },
  chatBotUrl:
    'https://aichatbot-ui-copilot-web-dev-ntpaja4wua23a.azurewebsites.net/chat',
};
